// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=UTF-8,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%23888%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpolyline points=%276 9 12 15 18 9%27%3e%3c/polyline%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================================
   EXPLORE PAGE STYLES
   ========================================= */

.explore-header {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    margin-bottom: 2rem;
    align-items: center;
    position: relative;
}

.back-btn-modern {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    gap: 0.5rem;
    background: var(--glass-bg);
    border: 1px solid var(--glass-border);
    color: var(--text-main);
    padding: 0.5rem 1rem;
    border-radius: 12px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s;
    text-decoration: none;
}

.back-btn-modern:hover {
    background: var(--glass-hover);
    transform: translateY(-50%) translateX(-3px);
}

.filters-container {
    display: flex;
    gap: 1rem;
    flex-wrap: wrap;
    justify-content: center;
    width: 100%;
}

.modern-select {
    padding: 0.8rem 1.2rem;
    background: var(--input-bg);
    border: 1px solid var(--input-border);
    border-radius: 12px;
    color: var(--input-text);
    font-size: 1rem;
    cursor: pointer;
    outline: none;
    min-width: 180px;
    backdrop-filter: blur(10px);
    appearance: none;
    /* Remove default arrow */
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: right 1rem center;
    background-size: 1em;
}

/* Fix for dark options on some browsers */
.modern-select {
    color: var(--text-main);
}

.modern-select:focus {
    border-color: var(--primary);
    box-shadow: 0 0 0 2px rgba(var(--primary-rgb), 0.2);
}

.modern-select option {
    background-color: #1a1a2e;
    /* Match theme background precisely */
    color: #ffffff;
    padding: 12px;
}

[data-theme='light'] .modern-select option {
    background-color: #ffffff;
    color: #1a1a2e;
}


.explore-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
    gap: 1.5rem;
}

.student-card-explore {
    background: var(--glass-bg);
    border: 1px solid var(--glass-border);
    border-radius: 20px;
    padding: 1.5rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.student-card-explore:hover {
    transform: translateY(-5px);
    background: var(--glass-hover);
    box-shadow: var(--shadow-card);
    border-color: var(--glass-border);
}

.student-avatar-xl {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background: linear-gradient(135deg, var(--primary), #4f46e5);
    margin-bottom: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 2rem;
    font-weight: 700;
    color: white;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
}

.student-info-explore h3 {
    margin: 0;
    font-size: 1.1rem;
    color: var(--text-main);
    font-weight: 600;
}

.student-info-explore p {
    margin: 0.2rem 0;
    font-size: 0.9rem;
    color: var(--text-secondary);
}

.dept-badge {
    display: inline-block;
    padding: 0.25rem 0.75rem;
    background: var(--glass-border);
    border-radius: 20px;
    font-size: 0.8rem;
    color: var(--text-secondary);
    margin-top: 0.5rem;
}

.modern-refresh-btn {
    padding: 0.8rem 1.5rem;
    background: var(--glass-bg);
    border: 1px solid var(--glass-border);
    border-radius: 12px;
    color: var(--text-main);
    font-size: 1rem;
    font-weight: 600;
    cursor: pointer;
    outline: none;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    transition: all 0.2s ease-in-out;
    backdrop-filter: blur(10px);
}

.modern-refresh-btn:hover:not(:disabled) {
    background: var(--glass-hover);
    border-color: var(--primary);
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(var(--primary-rgb), 0.2);
}

.modern-refresh-btn:active:not(:disabled) {
    transform: translateY(0) scale(0.98);
}

.modern-refresh-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

@keyframes spin {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}

.spin-icon {
    animation: spin 1s linear infinite;
}`, "",{"version":3,"sources":["webpack://./src/pages/Explore.css"],"names":[],"mappings":"AAAA;;8CAE8C;;AAE9C;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,2BAA2B;IAC3B,qCAAqC;IACrC,uBAAuB;IACvB,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,8BAA8B;IAC9B,4CAA4C;AAChD;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,2BAA2B;IAC3B,qCAAqC;IACrC,mBAAmB;IACnB,wBAAwB;IACxB,eAAe;IACf,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,2BAA2B;IAC3B,gBAAgB;IAChB,yBAAyB;IACzB,yDAAqR;IACrR,4BAA4B;IAC5B,sCAAsC;IACtC,oBAAoB;AACxB;;AAEA,0CAA0C;AAC1C;IACI,uBAAuB;AAC3B;;AAEA;IACI,4BAA4B;IAC5B,mDAAmD;AACvD;;AAEA;IACI,yBAAyB;IACzB,qCAAqC;IACrC,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;;AAGA;IACI,aAAa;IACb,4DAA4D;IAC5D,WAAW;AACf;;AAEA;IACI,2BAA2B;IAC3B,qCAAqC;IACrC,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,qDAAqD;IACrD,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,8BAA8B;IAC9B,8BAA8B;IAC9B,iCAAiC;AACrC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,4DAA4D;IAC5D,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,yCAAyC;AAC7C;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,4BAA4B;AAChC;;AAEA;IACI,qBAAqB;IACrB,wBAAwB;IACxB,+BAA+B;IAC/B,mBAAmB;IACnB,iBAAiB;IACjB,4BAA4B;IAC5B,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,2BAA2B;IAC3B,qCAAqC;IACrC,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,gCAAgC;IAChC,2BAA2B;AAC/B;;AAEA;IACI,8BAA8B;IAC9B,4BAA4B;IAC5B,2BAA2B;IAC3B,oDAAoD;AACxD;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,kCAAkC;AACtC","sourcesContent":["/* =========================================\n   EXPLORE PAGE STYLES\n   ========================================= */\n\n.explore-header {\n    display: flex;\n    flex-direction: column;\n    gap: 1.5rem;\n    margin-bottom: 2rem;\n    align-items: center;\n    position: relative;\n}\n\n.back-btn-modern {\n    position: absolute;\n    left: 0;\n    top: 50%;\n    transform: translateY(-50%);\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    background: var(--glass-bg);\n    border: 1px solid var(--glass-border);\n    color: var(--text-main);\n    padding: 0.5rem 1rem;\n    border-radius: 12px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.2s;\n    text-decoration: none;\n}\n\n.back-btn-modern:hover {\n    background: var(--glass-hover);\n    transform: translateY(-50%) translateX(-3px);\n}\n\n.filters-container {\n    display: flex;\n    gap: 1rem;\n    flex-wrap: wrap;\n    justify-content: center;\n    width: 100%;\n}\n\n.modern-select {\n    padding: 0.8rem 1.2rem;\n    background: var(--input-bg);\n    border: 1px solid var(--input-border);\n    border-radius: 12px;\n    color: var(--input-text);\n    font-size: 1rem;\n    cursor: pointer;\n    outline: none;\n    min-width: 180px;\n    backdrop-filter: blur(10px);\n    appearance: none;\n    /* Remove default arrow */\n    background-image: url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23888' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e\");\n    background-repeat: no-repeat;\n    background-position: right 1rem center;\n    background-size: 1em;\n}\n\n/* Fix for dark options on some browsers */\n.modern-select {\n    color: var(--text-main);\n}\n\n.modern-select:focus {\n    border-color: var(--primary);\n    box-shadow: 0 0 0 2px rgba(var(--primary-rgb), 0.2);\n}\n\n.modern-select option {\n    background-color: #1a1a2e;\n    /* Match theme background precisely */\n    color: #ffffff;\n    padding: 12px;\n}\n\n[data-theme='light'] .modern-select option {\n    background-color: #ffffff;\n    color: #1a1a2e;\n}\n\n\n.explore-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));\n    gap: 1.5rem;\n}\n\n.student-card-explore {\n    background: var(--glass-bg);\n    border: 1px solid var(--glass-border);\n    border-radius: 20px;\n    padding: 1.5rem;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);\n    cursor: pointer;\n    position: relative;\n    overflow: hidden;\n}\n\n.student-card-explore:hover {\n    transform: translateY(-5px);\n    background: var(--glass-hover);\n    box-shadow: var(--shadow-card);\n    border-color: var(--glass-border);\n}\n\n.student-avatar-xl {\n    width: 80px;\n    height: 80px;\n    border-radius: 50%;\n    background: linear-gradient(135deg, var(--primary), #4f46e5);\n    margin-bottom: 1rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 2rem;\n    font-weight: 700;\n    color: white;\n    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);\n}\n\n.student-info-explore h3 {\n    margin: 0;\n    font-size: 1.1rem;\n    color: var(--text-main);\n    font-weight: 600;\n}\n\n.student-info-explore p {\n    margin: 0.2rem 0;\n    font-size: 0.9rem;\n    color: var(--text-secondary);\n}\n\n.dept-badge {\n    display: inline-block;\n    padding: 0.25rem 0.75rem;\n    background: var(--glass-border);\n    border-radius: 20px;\n    font-size: 0.8rem;\n    color: var(--text-secondary);\n    margin-top: 0.5rem;\n}\n\n.modern-refresh-btn {\n    padding: 0.8rem 1.5rem;\n    background: var(--glass-bg);\n    border: 1px solid var(--glass-border);\n    border-radius: 12px;\n    color: var(--text-main);\n    font-size: 1rem;\n    font-weight: 600;\n    cursor: pointer;\n    outline: none;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.5rem;\n    transition: all 0.2s ease-in-out;\n    backdrop-filter: blur(10px);\n}\n\n.modern-refresh-btn:hover:not(:disabled) {\n    background: var(--glass-hover);\n    border-color: var(--primary);\n    transform: translateY(-2px);\n    box-shadow: 0 4px 12px rgba(var(--primary-rgb), 0.2);\n}\n\n.modern-refresh-btn:active:not(:disabled) {\n    transform: translateY(0) scale(0.98);\n}\n\n.modern-refresh-btn:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n}\n\n@keyframes spin {\n    from {\n        transform: rotate(0deg);\n    }\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n.spin-icon {\n    animation: spin 1s linear infinite;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
